import React from "react";
import Button from "components/button";
import Featured from "./Featured";


const CategoryFilter = ({ categories = [], value, onChange, className = "", onBrowseAll }) => {

    return (
        <div className={className}>
            <div className={`flex gap-2 pb-6 ${className}`}>
                {categories.map((item) => {
                    const isActive = value === item.value;
                    const Icon = item.icon;

                    const buttonClass = isActive
                    ? "access-button btn-category"
                    : "access-button btn-filter border !h-9 !px-4 py-2 !text-sm ";

                    return (
                        <Button
                            key={item.value}
                            onClick={() => onChange(item.value)}
                            variant={isActive ? "default" : "outline"}
                            className={buttonClass}
                        >
                            {Icon && <Icon className="w-4 h-4 mr-2" />}
                            {item.label}
                        </Button>
                    );
                })}
            </div>
            {value === "all" && <Featured onBrowseAll={onBrowseAll}/>}
        </div>
    );
};

export default CategoryFilter;
